import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import _ from "lodash";
import API from "@/api/index";
import moment from "moment";
import Storage from "vue-web-storage";
import PageHeader from "@/components/PageHeader.vue";
import VueDaumPostcode from "vue-daum-postcode";
import {Visibility50Directive} from "@/utils/visibilityWatcher";
import StoragePlugin from 'vue-web-storage';
import VueDayjs from 'vue3-dayjs-plugin'
import {vfmPlugin} from "vue-final-modal";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import SimpleVueValidator from 'simple-vue3-validator'
import 'element-plus/dist/index.css'
import PageFooter from '@/components/PageFooter.vue';
import coinBalanceReturnSyncMixin from "@/mixins/coinBalanceReturnSyncMixin";

// window.$ = $;
window.global = window;
import ElementPlus from 'element-plus'
import 'dayjs/locale/ko';
import Api from "@/api/index";
let app = createApp(App);
app.mixin(coinBalanceReturnSyncMixin);
import ko from "element-plus/dist/locale/ko"
import $ from "jquery";
window.$ = $
// const gAuthOptions = { clientId: '444709038496-25jgkmo8lb5ganputrjrep9a9leutgpm.apps.googleusercontent.com', scope: 'email', prompt: 'consent'}
// app.use(GAuth, gAuthOptions)
app.use(store);
app.use(router)
app.use(vfmPlugin)
app.use(SimpleVueValidator)

app.use(VueDaumPostcode)
app.use(StoragePlugin, {
  prefix:  'com.dgmonglab.rainbow-tv-web',
  drivers: ['local'],
})


app.config.globalProperties.$api = Api;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$_ = _;
app.directive('visibility50', Visibility50Directive);
app.use(ElementPlus, {
  locale: ko
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(VueDayjs)
app.component('page-header', PageHeader)
app.component('page-footer', PageFooter)
app.use(store)
app.mount('#app')
